import { darken } from '@mui/material/styles';
import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  productGallery: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  productGallerySlider: {
    '& .swiper-pagination': {
      bottom: '25px !important'
    }
  },
  productGalleryImageWrapper: {
    '& > div': {
      backgroundColor: '#F7F7F7',
    },
    '& img': {
      mixBlendMode: 'darken',
    }
  },
  productInfo: {
    padding: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 0, 4, 4),
      marginLeft: theme.spacing(6),
    }
  },
  productDescription: {
    fontSize: 14,
    lineHeight: 1.5,
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    }
  },
  productDescriptionSmall: {
    fontSize: 12,
    lineHeight: 1.5,
    [theme.breakpoints.up('md')]: {
      fontSize: 13,
    }
  },
  photoGrid: {
    marginBottom: theme.spacing(16),
    display: 'grid',
    gridGap: 20,
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
  },
  photoGridColumn: {
    height: 300,
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('lg')]: {
      height: 450,
    }
  },
  photoGridPhoto: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  designConsultCTA: {
    height: 60,
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #000',
    padding: theme.spacing(1.5),
    backgroundColor: '#fff',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoAccordion: {
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    position: 'relative',
    borderBottom: '.1rem solid #ddd',
    '&::before': {
      display: 'none',
    },
    '&:first-of-type': {
      borderTop: '.1rem solid #ddd',
    }
  },
  infoAccordionIcon: {
    height: 'auto',
    width: 24,
    fill: theme.palette.common.black,
  },
  infoQuestion: {
    color: theme.palette.common.black,
    fontSize: 14,
    fontWeight: 500,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    }
  },
  infoAnswer: {
    fontSize: 13,
    lineHeight: 1.6,
    fontWeight: 'normal',
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    },
    '& a': {
      color: '#83A5B0',
      fontWeight: 'bold',
    },
    '& a:hover': {
      color: darken('#83A5B0', .2),
    }
  }
}));
